import { Link, useSearchParams } from 'react-router';

export default function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const status = searchParams.get('status');
  const verified = status === 'success' || searchParams.get('verified') === '1';
  const failed = status === 'error' || status === 'invalid';

  return (
    <div className="flex min-h-screen items-center justify-center bg-[var(--color-surface-container-low)] px-6">
      <div className="w-full max-w-sm space-y-8">
        <div className="rounded-3xl bg-card p-8 shadow-ambient text-center space-y-4">
          {verified ? (
            <>
              <h1 className="display-tight text-2xl font-semibold">Email verified</h1>
              <p className="text-sm text-muted-foreground">
                You're all set. Sign in to start planning.
              </p>
              <Link
                to="/login"
                className="btn-primary-gradient inline-flex h-11 items-center justify-center rounded-full px-6 text-sm font-medium text-white shadow-ambient"
              >
                Continue to sign in
              </Link>
            </>
          ) : failed ? (
            <>
              <h1 className="display-tight text-2xl font-semibold">Link invalid</h1>
              <p className="text-sm text-muted-foreground">
                This verification link is invalid or has expired. Sign in to request a new one.
              </p>
              <Link
                to="/login"
                className="btn-primary-gradient inline-flex h-11 items-center justify-center rounded-full px-6 text-sm font-medium text-white shadow-ambient"
              >
                Back to sign in
              </Link>
            </>
          ) : (
            <>
              <h1 className="display-tight text-2xl font-semibold">Check your email</h1>
              <p className="text-sm text-muted-foreground">
                We sent a verification link to your inbox. Click it to activate your account.
              </p>
              <Link
                to="/login"
                className="text-sm font-medium text-secondary underline-offset-4 hover:underline"
              >
                Back to sign in
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
